import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  IconButton,
  Link,
  Snackbar,
  Alert,
  Paper,
  Divider,
} from '@mui/material';
import {
  LocationOn,
  Phone,
  Email,
  Facebook,
  Twitter,
  LinkedIn,
  Instagram,
  Send,
} from '@mui/icons-material';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Here you would typically send the form data to your backend or email service
    setForm({ name: '', email: '', message: '' });
  };

  const contactInfo = [
    {
      icon: <LocationOn sx={{ fontSize: 40, color: 'primary.main' }} />,
      title: 'Address',
      content: 'Department of Computer Science & Engineering\nMBM University\nJodhpur, Rajasthan - 342011',
    },
    {
      icon: <Phone sx={{ fontSize: 40, color: 'primary.main' }} />,
      title: 'Phone',
      content: '+91 291 1234567\n+91 291 7654321',
    },
    {
      icon: <Email sx={{ fontSize: 40, color: 'primary.main' }} />,
      title: 'Email',
      content: 'cse@mbm.ac.in\nhod.cse@mbm.ac.in',
    },
  ];

  const socialLinks = [
    {
      icon: <Facebook />,
      link: 'https://facebook.com/mbmcse',
      label: 'Facebook',
    },
    {
      icon: <Twitter />,
      link: 'https://twitter.com/mbmcse',
      label: 'Twitter',
    },
    {
      icon: <LinkedIn />,
      link: 'https://linkedin.com/company/mbmcse',
      label: 'LinkedIn',
    },
    {
      icon: <Instagram />,
      link: 'https://instagram.com/mbmcse',
      label: 'Instagram',
    },
  ];

  return (
    <Box sx={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)', minHeight: '90vh', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
          <Typography variant="h3" align="center" sx={{ fontWeight: 800, mb: 2, color: 'primary.main' }}>
            Contact Us
          </Typography>
          <Typography align="center" sx={{ mb: 4, color: 'text.secondary' }}>
            We'd love to hear from you! Reach out for any queries, or send us your feedback below.
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
                  Contact Information
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <LocationOn sx={{ color: 'primary.main', mr: 1 }} />
                  <Typography variant="body1">MBM University, Jodhpur, Rajasthan, India</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Phone sx={{ color: 'primary.main', mr: 1 }} />
                  <Typography variant="body1">+91 123 456 7890</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Email sx={{ color: 'primary.main', mr: 1 }} />
                  <Typography variant="body1">cse@mbm.ac.in</Typography>
                </Box>
              </Box>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
                Feedback
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Your feedback helps us improve. Please use the form to share your thoughts or suggestions.
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <TextField
                  label="Name"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  label="Email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  label="Message / Feedback"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  fullWidth
                  multiline
                  minRows={4}
                  variant="outlined"
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  endIcon={<Send />}
                  sx={{ fontWeight: 700, borderRadius: 2 }}
                >
                  Send Message
                </Button>
                {submitted && (
                  <Typography color="success.main" sx={{ mt: 2, fontWeight: 500 }}>
                    Thank you for your feedback! We appreciate your input.
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default Contact; 